import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { Container } from '../Container';
export function FinalCta() {
  return <section className="py-24 bg-pts-red text-white text-center relative overflow-hidden" data-id="element-147">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#fff 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-148"></div>

      <Container className="relative z-10" data-id="element-149">
        <h2 className="font-oswald text-4xl md:text-5xl lg:text-6xl font-bold uppercase mb-6" data-id="element-150">
          Ready to Get Your Team in Custom Gear?
        </h2>
        <p className="text-xl text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-151">
          Tell us your sport, team size, timeline, and what you need. If you
          already have a quote, send it over and we'll help you compare.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-152">
          <Link to="/get-started" className="bg-white text-pts-red hover:bg-gray-100 px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors w-full sm:w-auto shadow-lg" data-id="element-153">
            Start My Team Order
          </Link>
          <Link to="/contact" className="bg-transparent border-2 border-white hover:bg-white hover:text-pts-red text-white px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors w-full sm:w-auto" data-id="element-154">
            Send Us Your Quote
          </Link>
        </div>

        <div className="mt-8 flex justify-center" data-id="element-155">
          <a href="tel:8882188647" className="flex items-center text-white/90 hover:text-white font-bold text-lg transition-colors" data-id="element-156">
            <Phone className="h-5 w-5 mr-2" data-id="element-157" />
            Call 888.218.8647
          </a>
        </div>
      </Container>
    </section>;
}